import { ManifoldMonoBadgeIcon } from "~/assets/icons";
import { cn } from "~/lib/utils";

interface RoleLabelProps {
  roleName: string;
  className?: string;
  isInternal?: boolean;
}

const RoleLabel = ({ roleName, className, isInternal = false }: RoleLabelProps) => {
  return (
    <span className={cn("inline-flex items-center gap-0.5 min-w-0", className)}>
      <span className="truncate">{roleName}</span>
      {isInternal && <ManifoldMonoBadgeIcon className="w-[14px] h-[11px] shrink-0" />}
    </span>
  );
};

export default RoleLabel;
